import { render, staticRenderFns } from "./FaqsNoCallOutCharge.vue?vue&type=template&id=95979310&scoped=true"
import script from "./FaqsNoCallOutCharge.vue?vue&type=script&lang=js"
export * from "./FaqsNoCallOutCharge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95979310",
  null
  
)

export default component.exports